import {Component, OnInit} from '@angular/core';
import {UserService, IAppSettings, WebUserModel} from 'web-shared';
import {AuthService} from 'web-shared';
import {StateService} from 'web-shared';
import {ToastrService} from "ngx-toastr";
import {BaseComponent, GLOBAL, LocalizationService, PRIVILEGES} from 'common-shared';
import {map, takeUntil} from "rxjs/operators";
import {AsprovaService} from "../asprova.service";
import {ConfigService, ManufacturingItemGroupService} from "ime-shared";

@Component({
  selector: 'metec-web-navigation',
  templateUrl: './metec-navigation.component.html'
})
export class MetecNavigationComponent extends BaseComponent implements OnInit {
  isCollapsed = true;
  bgClass = 'bg-dark';
  user: WebUserModel;
  settings: IAppSettings;
  Classificators = GLOBAL.Classificators;
  protected readonly PRIVILEGES = PRIVILEGES;

  constructor(public stateService: StateService, public authService: AuthService, public manufacturedItemGroupService: ManufacturingItemGroupService, private configService: ConfigService, private toastrService: ToastrService, private localizationService: LocalizationService, public userService: UserService, private asprovaService: AsprovaService) {
    super();
  }

  ngOnInit() {
    this.stateService.currentUser$.pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      this.user = value;
    });
    this.stateService.settings$.pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      this.settings = value;
      this.bgClass = JSON.parse(this.settings.ClientOptions ?? '{}').Mode === 'DEMO' ? 'bg-red' : 'bg-dark';
    });
  }

  resetAllCaches() {
    this.configService.resetCaches().pipe(takeUntil(this.componentDestroyed)).subscribe(value => true);
  }

  resetBrowserCaches() {
    this.configService.clearStorageCache();
  }

  private showSuccess(message: string = 'Calculated') {
    this.toastrService.success(message);
  }

  addKeys() {
    this.localizationService.addKeysFromPath(`../../../assets/i18n/`).pipe(takeUntil(this.componentDestroyed)).subscribe();
  }

  asprovaSync() {
    this.asprovaService.imeSync().pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      this.showSuccess('IME Synced');
    });
  }

  responseExTest() {
    this.configService.responseExceptionTest().pipe(takeUntil(this.componentDestroyed)).subscribe();
  }

  responseTest() {
    this.configService.responseTest().pipe(takeUntil(this.componentDestroyed)).subscribe();
  }

  progressMessagesTest() {
    this.configService.progressMessagesTest().pipe(takeUntil(this.componentDestroyed)).subscribe();
  }

  progressMessagesForUserTest() {
    this.configService.progressMessagesForUserTest().pipe(takeUntil(this.componentDestroyed)).subscribe();
  }

  setLogTimingData(logging: boolean) {
    this.configService.setLogTimingData(logging).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      const message = value
        ? 'Päringute kestuse logimine sisse lülitatud kuni 23:59 või välja lülitamiseni.'
        : 'Päringute kestuse logimine välja lülitatud.'
      this.showSuccess(message);
    });
  }

  toastTest() {
    this.toastrService.info('Info message', 'Info title');
    this.toastrService.error('Error message', 'Error title');
    this.toastrService.warning('Warning message', 'Warning title');
  }
}
